export const SembonusIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <mask
        id="mask0_10869_3590"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20"
      >
        <rect width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_10869_3590)">
        <path
          d="M17.1939 11.6475L11.6683 17.194C11.5308 17.3306 11.3813 17.4297 11.2198 17.4913C11.0582 17.5527 10.8903 17.5834 10.716 17.5834C10.5416 17.5834 10.3741 17.5527 10.2135 17.4913C10.0529 17.4297 9.90433 17.3306 9.76767 17.194L2.80788 10.2421C2.66996 10.1096 2.57024 9.96245 2.50871 9.80065C2.44732 9.63884 2.41663 9.46863 2.41663 9.29002V3.7644C2.41663 3.39384 2.54746 3.07655 2.80913 2.81252C3.07093 2.54863 3.38933 2.41669 3.76433 2.41669H9.28996C9.46218 2.41669 9.62906 2.4471 9.79058 2.50794C9.95211 2.56863 10.1002 2.66592 10.2348 2.79981L17.1939 9.75169C17.3327 9.88919 17.4336 10.0352 17.4966 10.1896C17.5597 10.3442 17.5912 10.5097 17.5912 10.6861C17.5912 10.8625 17.5595 11.0328 17.4962 11.1971C17.4329 11.3614 17.3321 11.5115 17.1939 11.6475ZM10.9023 16.4198L16.4279 10.8942C16.4812 10.8409 16.5079 10.7781 16.5079 10.7059C16.5079 10.6338 16.4812 10.5711 16.4279 10.5177L9.40225 3.50794H3.76433C3.68961 3.50794 3.62683 3.53203 3.576 3.58023C3.52531 3.62828 3.49996 3.68967 3.49996 3.7644V9.29815C3.49996 9.33023 3.50531 9.36224 3.516 9.39419C3.5267 9.42627 3.54538 9.45565 3.57204 9.48231L10.5256 16.4198C10.5791 16.4733 10.6418 16.5 10.7139 16.5C10.786 16.5 10.8488 16.4733 10.9023 16.4198ZM5.52079 6.56565C5.81135 6.56565 6.05815 6.4644 6.26121 6.2619C6.46413 6.0594 6.56558 5.81342 6.56558 5.52398C6.56558 5.23245 6.46433 4.98467 6.26183 4.78064C6.05933 4.57648 5.81336 4.4744 5.52392 4.4744C5.23239 4.4744 4.98461 4.57613 4.78058 4.7796C4.57642 4.98308 4.47433 5.23016 4.47433 5.52085C4.47433 5.81141 4.57607 6.05821 4.77954 6.26127C4.98301 6.46419 5.2301 6.56565 5.52079 6.56565Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};
